import React, { useState, useEffect, useImperativeHandle, useMemo, useCallback, ReactNode, useRef, forwardRef, useContext } from "react";
import classnames from 'classnames';
import { useUser } from "@/contexts/UserContext";
import { getAllProducts } from "@/services/product.service";
import { getAccessLevel } from "@/utils/storiesUtil";
import { storyToHide } from "@/config/globalVars";
import { TenantCompany } from "@/types/ApiTypes";
const imageBucketURL = import.meta.env.REACT_APP_IMAGES_BASE_URL;


export const useStories = (
    onlySubscribed = true,
    // limitToAccesssLevel = false,
    limitToSubscriptionLevel = true,
) => {
    const {subscribedSkus, company, user} = useUser();

    const userAccessLevel = company?.accessLevel ? parseInt(getAccessLevel(company?.accessLevel)!) : 0;

    const isValidStory = useCallback((storyProduct: ProductWithMeta, index: number, arr: (typeof storyProduct)[]) => {    
        // In Progress
        if (storyToHide?.includes(storyProduct?.sku) && 2 <= userAccessLevel && userAccessLevel <= 4) {
            return false; // brand review story not to be shown to user
        } else {
            return (
                storyProduct?.type === 'story' &&
                (Boolean(limitToSubscriptionLevel) && Number.isFinite(storyProduct?.subscriptionLevel)) &&
                Boolean(storyProduct?.sku) &&
                storyProduct?.title !== '' &&
                Boolean(storyProduct?.metadata?.env?.reportRunValue) &&
                Boolean(storyProduct?.metadata?.env?.reportSelectors) &&
                Boolean(storyProduct?.metadata?.env?.objective_lists) &&
                storyProduct?.metadata?.env?.reportSelectors?.length !== 0 &&
                Object.keys(storyProduct?.metadata?.env?.objective_lists).length !== 0

                && (onlySubscribed && subscribedSkus.includes(storyProduct?.sku))
            );
        }
    }, [company, storyToHide, userAccessLevel, subscribedSkus, limitToSubscriptionLevel, onlySubscribed]);
    
    const allProducts = getAllProducts();

    const finalStories = useMemo(() => {
        const stories = allProducts
            .filter(({ type }) => type === 'story')
            .filter(isValidStory)
            .map(story => {
                if (!story?.thumbnailUrl?.includes(imageBucketURL, 0)) {
                    return {
                        ...story,
                        thumbnailUrl: imageBucketURL + story?.thumbnailUrl
                    }
                }
                return story;
            }) 

        return stories;
    }, [allProducts, subscribedSkus, onlySubscribed, imageBucketURL]);


    return finalStories;

};

export default useStories;

useStories.displayName = 'useStories';